import { Vector3 } from 'three'

export const TABS = {
  primary: 'primary',
  secondary: 'secondary',
  columns: 'columns',
} as const

export const NUMBERS = Array(26)
  .fill(null)
  .map((_, i) => i)
  .join(',')

export const formatOptionsWithId = <T extends { value: string }>(opts: T[]) =>
  opts.map(({ value }) => ({ id: value, value }))

const DOWN_Y = new Vector3(0, -1, 0)
const UP = new Vector3(0, 0, 1)
export const getBeamOrientation = (rotation: number) => DOWN_Y.clone().applyAxisAngle(UP, rotation).round()
export const getOrthoOrientation = ({ x, y, z }: Vector3) =>
  new Vector3(Math.abs(x), Math.abs(y), z).applyAxisAngle(UP, -Math.PI / 2)
